import React from 'react';
import { Mail, MapPin, Instagram, Truck, Phone } from 'lucide-react';
import { WhatsAppIcon, WHATSAPP_DISPLAY, waLink } from './Effects';

const Footer = () => {
  return (
    <footer className="bg-[#0f1a12] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <img src="/assets/logo.png" alt="FBD Cleaning" className="h-14 w-auto object-contain bg-white rounded-xl p-1.5 inline-block" />
            <p className="mt-5 text-white/60 max-w-md text-sm leading-relaxed">
              FBD Cleaning (by FBD House Care) makes everyday hygiene simple and effective. Premium,
              high-performance home & personal care products for a cleaner tomorrow.
            </p>
            <div className="mt-5 inline-flex items-center gap-2 bg-primary/20 text-primary-foreground px-3 py-1.5 rounded-full text-sm">
              <Truck className="h-4 w-4" /> Cash on Delivery available
            </div>
          </div>

          <div>
            <h4 className="font-display font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2.5 text-white/60 text-sm">
              {[['Home', '#home'], ['Products', '#products'], ['Reviews', '#reviews'], ['Founders', '#founders'], ['Contact', '#contact']].map(([l, h]) => (
                <li key={h}><a href={h} className="hover:text-primary transition-colors">{l}</a></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-lg mb-4">Get in Touch</h4>
            <ul className="space-y-3 text-white/60 text-sm">
              <li>
                <a data-testid="footer-whatsapp-link" href={waLink('Hi FBD Cleaning!')} target="_blank" rel="noreferrer" className="flex items-start gap-2 hover:text-[#25D366] transition-colors">
                  <WhatsAppIcon className="h-4 w-4 mt-0.5 text-[#25D366]" /> {WHATSAPP_DISPLAY}
                </a>
              </li>
              <li className="flex items-start gap-2"><Phone className="h-4 w-4 mt-0.5 text-primary" /> <a data-testid="footer-phone-link" href="tel:+918287651258" className="hover:text-primary transition-colors">{WHATSAPP_DISPLAY}</a></li>
              <li className="flex items-start gap-2"><Mail className="h-4 w-4 mt-0.5 text-primary" /> customercare@fbd-cleaning.com</li>
              <li className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 text-primary" /> New Industrial Township, Faridabad, Haryana 121001</li>
              <li className="flex items-start gap-2"><Instagram className="h-4 w-4 mt-0.5 text-primary" /> @fbd.cleaning</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-white/50 text-sm">
          <p>© {new Date().getFullYear()} FBD Cleaning – A Trademark of FBD House Care. All rights reserved.</p>
          <p>Made with care in Faridabad, India.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
